import React from 'react';
import { motion } from 'framer-motion';
export function Features() {
  return <section id="features" className="py-24 border-b border-stone-300" data-id="element-857">
      <div className="max-w-6xl mx-auto px-6" data-id="element-858">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-859">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-860">
            {/* Left: Header */}
            <div className="lg:col-span-4" data-id="element-861">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-862">
                Platform
              </p>

              <h2 className="font-serif text-4xl tracking-tight leading-[1.1] text-stone-900 mb-6" data-id="element-863">
                Everything you need to quote, hold, and close
              </h2>

              <p className="text-lg text-stone-600 leading-relaxed" data-id="element-864">
                A complete operating system for group travel distribution. Built
                for revenue teams who need control.
              </p>
            </div>

            {/* Right: Feature list */}
            <div className="lg:col-span-8" data-id="element-865">
              <div className="border-t border-stone-300" data-id="element-866">
                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-867">
                  <div className="col-span-1" data-id="element-868">
                    <span className="font-mono text-xs text-stone-400" data-id="element-869">01</span>
                  </div>
                  <div className="col-span-4" data-id="element-870">
                    <p className="font-medium text-stone-900" data-id="element-871">
                      Multi-Property Quotes
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-872">
                    <p className="text-stone-600" data-id="element-873">
                      Instant quotes across your entire portfolio. Room blocks,
                      dates, occupancy, event needs—handled in seconds.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-874">
                  <div className="col-span-1" data-id="element-875">
                    <span className="font-mono text-xs text-stone-400" data-id="element-876">02</span>
                  </div>
                  <div className="col-span-4" data-id="element-877">
                    <p className="font-medium text-stone-900" data-id="element-878">Smart Holds</p>
                  </div>
                  <div className="col-span-7" data-id="element-879">
                    <p className="text-stone-600" data-id="element-880">
                      Automated hold timers with expiry management. Inventory
                      secured, no manual follow-ups required.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-881">
                  <div className="col-span-1" data-id="element-882">
                    <span className="font-mono text-xs text-stone-400" data-id="element-883">03</span>
                  </div>
                  <div className="col-span-4" data-id="element-884">
                    <p className="font-medium text-stone-900" data-id="element-885">
                      Package Builder
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-886">
                    <p className="text-stone-600" data-id="element-887">
                      Good / Better / Best options auto-generated within your
                      pricing policy. Maximize conversion, protect margins.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-888">
                  <div className="col-span-1" data-id="element-889">
                    <span className="font-mono text-xs text-stone-400" data-id="element-890">04</span>
                  </div>
                  <div className="col-span-4" data-id="element-891">
                    <p className="font-medium text-stone-900" data-id="element-892">
                      Proposal Generation
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-893">
                    <p className="text-stone-600" data-id="element-894">
                      Standardized, branded proposals exported in one click.
                      Ready for client presentation.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-895">
                  <div className="col-span-1" data-id="element-896">
                    <span className="font-mono text-xs text-stone-400" data-id="element-897">05</span>
                  </div>
                  <div className="col-span-4" data-id="element-898">
                    <p className="font-medium text-stone-900" data-id="element-899">Policy Engine</p>
                  </div>
                  <div className="col-span-7" data-id="element-900">
                    <p className="text-stone-600" data-id="element-901">
                      Rate floors, blackout dates, concession limits—enforced
                      automatically across all quotes.
                    </p>
                  </div>
                </div>

                <div className="py-6 grid grid-cols-12 gap-4" data-id="element-902">
                  <div className="col-span-1" data-id="element-903">
                    <span className="font-mono text-xs text-stone-400" data-id="element-904">06</span>
                  </div>
                  <div className="col-span-4" data-id="element-905">
                    <p className="font-medium text-stone-900" data-id="element-906">Audit Trail</p>
                  </div>
                  <div className="col-span-7" data-id="element-907">
                    <p className="text-stone-600" data-id="element-908">
                      Every quote, change, and approval tracked and reportable.
                      Complete visibility for revenue teams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}